<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-08 15:35:23
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card assistant-card" style="width: 3.54rem; position: relative;">
    <div class="card-header tips">AI助手</div>
    <div class="assistant-scroll">
      <!-- 客户要求：注释说明文案「智能问答、日程管理…」不再展示
      <div class="info intro-line">
        智能问答、日程管理、任务提醒、会议安排、工作任务
      </div>
      -->
      <div
        class="info agent-item"
        v-for="(item,index) in quickFuncList"
        :key="index"
        @click="handleQuickFuncClick(item)">
        <div class="tips-E5A135">{{ item.agentName || item.name }}</div>
      </div>
    </div>
    <div class="button" @click="handleStartChat">
      开始对话
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      quickFuncList: [] // 快速功能列表
    }
  },
  computed: {},
  created () {
    this.getQuickFuncList()
  },
  methods: {
    // 获取快速功能列表
    getQuickFuncList () {
      this.$request.post('/sso/hiAgent/config/findList', {}).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 根据实际返回的数据结构调整，可能是 data.list 或 data.records 等
          const list = data.list || data.records || data || []
          // 只取前3个显示
          this.quickFuncList = list.slice(0, 3)
        }
      }).catch(err => {
        console.error('获取快速功能列表失败:', err)
        this.quickFuncList = []
      })
    },
    // 点击快速功能项
    handleQuickFuncClick (item) {
      const agentId = item.id || item.agentId
      if (agentId) {
        // 跳转到AI助手页面，并传递 agentId 参数
        this.$router.push({
          name: 'assistant',
          query: { agentId: agentId }
        })
      }
    },
    // 点击开始对话按钮
    handleStartChat () {
      // 如果有快速功能列表，默认选择第一个
      if (this.quickFuncList.length > 0) {
        const firstItem = this.quickFuncList[0]
        const agentId = firstItem.id || firstItem.agentId
        if (agentId) {
          this.$router.push({
            name: 'assistant',
            query: { agentId: agentId }
          })
        } else {
          // 如果没有 agentId，直接跳转
          this.$router.push({ name: 'assistant' })
        }
      } else {
        // 如果没有快速功能列表，直接跳转
        this.$router.push({ name: 'assistant' })
      }
    }
  }
}
</script>
<style scoped lang="less">
.info{
  font-size: 17px;
  line-height: 1.5;
   cursor: pointer;
   transition: all 0.3s ease;

   &:hover {
     background-color: #f5f5f5;
     border-radius: 4px;
     padding: 4px 8px;
     margin: 0 -8px;
   }
}
.tips-E5A135 {
  padding-left: 20px;
  font-size: 17px;
  line-height: 1.5;
  position: relative;
  cursor: pointer;
  user-select: none;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    background: #E5A135;
    border-radius: 3px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.assistant-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.agent-item:first-of-type {
  margin-top: 4px;
}

.assistant-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 60px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
}

.button{
  width: 188px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: var(--primary-color, #E5A135);
  border-radius: 8px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  font-style: normal;
  position: absolute;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
}
</style>
